<template>
  <a-select v-model="curClassroomCode" :loading="classroomListLoading"
    :disabled="disabled"
    show-search
    :default-active-first-option="false"
    :show-arrow="true"
    :filter-option="false"
    :not-found-content="null"
    placeholder="请选择教室"
    @change="changeClassroom"
    @search="searchClassroomList"
    @popupScroll="getMore"
  >
    <a-select-option :value="classroom.classroomCode" v-for="classroom in classroomList" :key="classroom.classroomCode">
      {{ classroom.classroomName}}<i class="tip">{{ classroomTypeText[classroom.classroomType] }}</i>
    </a-select-option>
  </a-select>
</template>

<script>
import { checkRes } from '@/utils/tool'
import { searchClassroom } from '@/server/api/courseManage'
export default {
  name: 'ClassroomSelector', // 教室选择器
  props: {
    disabled: Boolean,
    dataItem: { // 听课学校和听课教室
      type: Object,
      default() {
        return {}
      }
    }
  },
  data () {
    return {
      classroomTypeText: {
        1: '沉浸式',
        12: '全景',
        13: '极简',
        14: '智慧',
      },
      classroomListLoading: false,
      curClassroomCode: undefined,
      classroomListPageSize: 20,
      classroomListPageNum: 1,
      classroomListRt: {},
      classroomList: [] // 老师列表
    }
  },
  mounted() {
  },
  watch: {
    "dataItem.schoolId": {
      handler(nVal, oVal) {
        if (!nVal) return
        this.getClassroomList(this.dataItem.classroomCode)
      },
      immediate: true
    },

  },
  methods: {
    changeClassroom(value) {
      this.curClassroomCode = value
      const curClassroom = this.classroomList.find(i => i.classroomCode === value)
      const dataItem = {
        ...this.dataItem,
        classroomCode: value,
        classroomType: curClassroom.classroomType
      }
      this.$emit('changeClassroom', dataItem)
    },
    getMore(e) {
      const { scrollHeight, scrollTop, clientHeight } = e.target
      const { classroomListLoading, classroomListPageSize, classroomListPageNum, classroomListRt } = this
      if (classroomListLoading) return
      if (scrollHeight - scrollTop < clientHeight + 20) {
        if ( classroomListPageNum * classroomListPageSize < classroomListRt.totalCount) {
          this.classroomListPageNum = classroomListPageNum + 1
          this.getClassroomList()
        }
      }
    },
    searchClassroomList(keyword) {
      this.classroomListPageNum = 1
      this.getClassroomList(keyword)
    },
    // 获取教室列表
    async getClassroomList(value) {
      const self = this
      const { classroomCode, schoolId } = self.dataItem
      self.classroomListLoading = true
      const res = await searchClassroom({
        schoolCode: schoolId,
        keywords: value,
        pageSize: self.classroomListPageSize,
        pageNum: self.classroomListPageNum
      })
      checkRes({
        res,
        success(data) {
          self.classroomListRt = data
          const list = data.list || []
          if (self.classroomListPageNum > 1) {
            self.classroomList = [...self.classroomList, ...list]
          } else {
            self.classroomList = list
          }
          const isExist = self.classroomList.find(i => i.classroomCode === classroomCode)
          self.changeClassroom(isExist ? classroomCode : (self.classroomList[0] || {}).classroomCode)
        }
      })
      self.classroomListLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .container{
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

  }
  .tip{
    color: rgb(95, 96, 211); font-size:12px;margin-left: 5px;font-style: italic;
  }
</style>